export const getDisableButtonDetailes = (statesAndReasons, currentState) => {
  const states = Array.from(statesAndReasons.keys())
  const isRefundButtonDisable = states.includes(currentState)

  const disableRefundReason = isRefundButtonDisable
    ? statesAndReasons.get(currentState)
    : null

  return { isRefundButtonDisable, disableRefundReason }
}
